export const breakpointsMixin = {
  data () {
    return {
      isDesktop: window.innerWidth > 768,
      isTablet: window.innerWidth < 767 && window.innerWidth > 601,
      isMobile: window.innerwidth <= 600,
      isTabletOverride: window.innerWidth <= 1100 && window.innerWidth > 601,
      windowWidth: window.innerWidth
    }
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', this.$_onResize)
      this.$_onResize()
    })
  },
  computed: {
    isDesktopView () {
      return this.isDesktop
    },
    isTabletView () {
      return this.isTablet
    },
    isMobileView () {
      return this.isMobile
    },
    isTabletOverrideView () {
      return this.isTabletOverride
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.$_onResize)
  },
  methods: {
    $_onResize () {
      this.isDesktop = window.innerWidth > 768
      this.isTablet = window.innerWidth <= 768 && window.innerWidth > 601
      this.isMobile = window.innerWidth <= 600
      this.isTabletOverride = window.innerWidth <= 1100 && window.innerWidth > 601
      this.windowWidth = window.innerWidth
    },
    $_isDesktopView () {
      return this.isDesktop
    },
    $_isTabletView () {
      return this.isTablet
    },
    $_isMobileView () {
      return this.isMobile
    },
    $_isTabletOverrideView () {
      return this.isTabletOverride
    }
  }
}
